import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ScanQrCode } from 'elements/eventView/ScanQrCode';
import { EFonts, EVariables } from 'libs/styles/styling';
import { Localization } from 'static/localization/localization';
import styled from 'styled-components/macro';

interface Props {
    background: string;
    title: string;
    color: string;
    date?: string;
    className?: string;
}

export const EventBanner = (props: Props): JSX.Element => {
    return (
        <S_EventBanner className={props.className} $background={props.background} id="about">
            <S_Title $color={props.color}>{props.title}</S_Title>
            {props.date && (
                <S_Date $color={props.color}>
                    <S_FontAwesomeIcon icon={['far', 'calendar']} />
                    <S_Desc>{props.date}</S_Desc>
                </S_Date>
            )}
            <S_Mobile>
                <S_ScanQrCode />
            </S_Mobile>
            <S_Open $color={props.color}>{Localization.OPEN_ON_YOUR_PHONE}</S_Open>
        </S_EventBanner>
    );
};

const S_EventBanner = styled.div<{ $background: string }>`
    width: 1260px;
    height: 305px;
    border-radius: ${EVariables.Radius2};
    position: relative;
    overflow: hidden;
    background-image: url(${(props) => props.$background});
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 55px 65px 80px 65px;
`;

const S_Title = styled.div<{ $color: string }>`
    font-size: 18px;
    font-family: ${EFonts.Bold};
    color: ${(props) => props.$color};
    font-size: 54px;
    letter-spacing: -1.62px;
`;

const S_Date = styled.div<{ $color: string }>`
    color: ${(props) => props.$color};
    display: flex;
    flex-direction: row;
    align-items: center;
`;

const S_FontAwesomeIcon = styled(FontAwesomeIcon)`
    margin: 0 20px 0 10px;
    font-size: 18px;
`;

const S_Desc = styled.div`
    font-family: ${EFonts.InterSemiBold};
    font-size: 16px;
    margin: 1px 0 0 0;
`;

const S_Mobile = styled.div`
    position: absolute;
    right: 20px;
    bottom: 0;
    width: 309px;
    height: 283px;
    background-image: url('https://dvtqxks0zalev.cloudfront.net/81df7477-d43e-4b2c-bf14-47f8c1567303.png');
    background-size: contain;
`;

const S_ScanQrCode = styled(ScanQrCode)`
    position: absolute;
    width: 130px;
    bottom: 54px;
    right: 97px;
`;

const S_Open = styled.div<{ $color: string }>`
    position: absolute;
    width: 250px;
    top: 20px;
    right: 59px;
    text-align: center;
    color: ${(props) => props.$color};
`;
